// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"513":"051178e0","515":"56d909a7"}[chunkId] + ".css";
};